// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Modal_wrapper__2g-Fp","modal":"Modal_modal__3upIc","header":"Modal_header__3AcpF","content":"Modal_content__1WqNT"};